import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PixService {
  url = signal(environment.apiUrl)

  private readonly http = inject(HttpClient)

  // pushElementToStack(body: any) {
  //   return this.http.post(`${this.url()}robot/push-to-queue`, body)
  // }

  // getQueueItemByReference(reference: string) {
  //   return this.http.get(`${this.url()}robot/get-from-queue/${reference}`);
  // }



  pushElementToStack(body: any) {
    // Ajusta la ruta 'pix/start-process' según como definiste tus rutas en el backend
    return this.http.post(`${this.url()}robot/start-process`, body);
  }

  // 2. CONSULTAR ESTADO (Devuelve { status: "PENDING" | "COMPLETED", data: ... })
  checkQueueStatus(processId: string) {
    return this.http.get(`${this.url()}robot/status/${processId}`);
  }

  // Este ya no se usaría para este flujo, pero puedes dejarlo si lo usas en otro lado
  getQueueItemByReference(reference: string) {
    return this.http.get(`${this.url()}robot/get-from-queue/${reference}`);
  }

}
